var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-description"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns small-offset-1 small-22"},[_c('div',{staticClass:"row"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:_vm.itemClass(index),domProps:{"innerHTML":_vm._s(item)}})}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1c032b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Benefits.vue
// module id = null
// module chunks = 